import { type ChangeEvent } from 'react'

import { type IConpanyContract, type ICompany, type ICompanyProgramItem, type IInsuredData } from '@/app/types/dmsTypes'

export type InputEvent = ChangeEvent<HTMLInputElement>
export type SelectEvent = ChangeEvent<HTMLSelectElement>
export type TextAreaEvent = ChangeEvent<HTMLTextAreaElement>

export const MODE_MAPPER: Record<string, string> = {
    companies: 'Страховые компании',
    insureds: 'Застрахованные пациенты'
}

export interface IDmsActionType {
    title: string
    type: string
    callback: () => void
    isDisabledRequired: boolean
    hasMarker?: boolean
}

export const paginationTopList = 10

export const onHandleNullableDtoParam = (param: string | null): string | null => param || null

export const addInsuredData: IInsuredData = {
    polisId: '',
    fname: '',
    iname: '',
    oname: null,
    birthDate: '',
    expirationDate: '',
    incuranceCompanyId: '',
    address: null,
    polisNumber: '',
    polisStartedAt: '',
    polisFinishedAt: null,
    insurer: '',
    contracts: [],
    phone: '',
    identificationMarkers: []
}

export const emptyCompanyData: ICompany = {
    id: '',
    inn: null,
    name: '',
    policyHoldersCount: 0,
    completionSoon: false
}

export const emptyContract: IConpanyContract = {
    id: '',
    name: '',
    conclusionAt: '',
    finishedAt: null,
    updateAt: null,
    completionSoon: false
}

export const emptyProgram: ICompanyProgramItem = {
    id: '',
    name: '',
    description: ''
}

export type TLoaderType = 'importList' | 'detachPatients'

export const BLANK_VALUE = '---'
